import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	header: {
		id: 'admin-pages-priorities.header',
		defaultMessage: 'Priorities',
		description: 'Page header for issue priorities in Jira',
	},
	description: {
		id: 'admin-pages-priorities.description',
		defaultMessage:
			'Add new priorities or edit the priority order by moving it up or down, or setting it to a specific position number.',
		description: 'Page description for issue priorities in Jira',
	},
	errorStateHeader: {
		id: 'admin-pages-priorities.error-state-header',
		defaultMessage: 'There was a problem loading your priorities',
		description: 'Error state header for retrieving issue priorities',
	},
	errorStateDescription: {
		id: 'admin-pages-priorities.error-state-description',
		defaultMessage: 'Please refresh your page to try again',
		description:
			'Error state description on what to do when there is an error with retrieving issue priorities',
	},
	addPriorityButton: {
		id: 'admin-pages-priorities.add-priority-button',
		defaultMessage: 'Add priority',
		description: 'Button in the header to open a modal which allows the user to add a priority',
	},
	moreButtonIconLabel: {
		id: 'admin-pages-priorities.more-button-icon-label',
		defaultMessage: 'More actions',
		description: 'Icon label for the more actions button',
	},
	assignAlertPriorities: {
		id: 'admin-pages-priorities.assign-alert-priorities',
		defaultMessage: 'Assign alert priorities',
		description: 'Button to assign alert priorities',
	},
	translatePriorities: {
		id: 'admin-pages-priorities.translate-priorities',
		defaultMessage: 'Translate priorities',
		description: 'Button to translate priorities',
	},
});
